// // src/App.js
// import React from 'react';
// import SubCategoryCard from './SubCategoryCard';

// const categories = [
//   {
//     id: 1,
//     title: 'Sarees',
//     subtitle: null,
//     bgColor: 'bg-custom-yellow-400',
//     bgPattern: 'bg-pattern-sarees',
//     textColor: 'text-custom-pink-500',
//     textShadow: 'text-shadow-sarees',
//     titleSize: 'text-3xl', // Tailwind's text-3xl for larger font
//   },
//   {
//     id: 2,
//     title: 'Cotton',
//     subtitle: 'Saree',
//     bgColor: 'bg-custom-purple-300',
//     bgPattern: 'bg-pattern-dots',
//     textColor: 'text-white',
//     textShadow: 'text-shadow-cotton',
//     titleSize: 'text-3xl',
//   },
//   {
//     id: 3,
//     title: 'PATTU SAREE',
//     subtitle: '(Silk Saree)',
//     bgColor: 'bg-custom-teal-300',
//     bgPattern: 'bg-pattern-clouds',
//     textColor: 'text-white',
//     textShadow: 'text-shadow-pattu',
//     titleSize: 'text-2xl', // Slightly smaller title for this card
//   },
//   {
//     id: 4,
//     title: 'FANCY',
//     subtitle: 'Saree',
//     bgColor: 'bg-custom-pink-300',
//     bgPattern: 'bg-pattern-checkerboard',
//     textColor: 'text-custom-yellow-300',
//     textShadow: 'text-shadow-fancy',
//     titleSize: 'text-3xl',
//   },
//   {
//     id: 5,
//     title: 'Trendy',
//     subtitle: 'Sarees',
//     bgColor: 'bg-custom-yellow-100',
//     bgPattern: 'bg-pattern-burst',
//     textColor: 'text-custom-teal-500',
//     textShadow: 'text-shadow-trendy',
//     titleSize: 'text-3xl',
//   },
//     {
//     id: 6,
//     title: 'Long',
//     subtitle: 'Gowns',
//     bgColor: 'bg-custom-purple-300',
//     bgPattern: 'bg-pattern-dots',
//     textColor: 'text-white',
//     textShadow: 'text-shadow-cotton',
//     titleSize: 'text-3xl',
//   },
//     {
//     id: 7,
//     title: 'Salwar',
//     subtitle: 'Kameez',
//     bgColor: 'bg-custom-pink-300',
//     bgPattern: 'bg-pattern-checkerboard',
//     textColor: 'text-custom-yellow-300',
//     textShadow: 'text-shadow-fancy',
//     titleSize: 'text-3xl',
//   },
// ];

// const SubCategoriesCards = () => {
//   return (
//     <div className="flex justify-center items-center p-4 bg-white">
//       <div className="flex flex-wrap justify-center gap-4"> {/* Use gap for spacing */}
//         {categories.map((category) => (
//           <SubCategoryCard key={category.id} category={category} />
//         ))}
//       </div>
//     </div>
//   );
// }

// export default SubCategoriesCards;

import React, { useMemo } from "react";
import { useCategories } from "../../hooks/useCategories";
import { useNavigate } from "react-router-dom";
import SubCategoriesCard from "./SubCategoryCard";

const STYLE_PRESETS = [
  {
    bgColor: "bg-custom-yellow-400",
    bgPattern: "bg-pattern-sarees",
    textColor: "text-custom-pink-500",
    textShadow: "text-shadow-sarees",
  },
  {
    bgColor: "bg-custom-purple-300",
    bgPattern: "bg-pattern-dots",
    textColor: "text-white",
    textShadow: "text-shadow-cotton",
  },
  {
    bgColor: "bg-custom-teal-300",
    bgPattern: "bg-pattern-clouds",
    textColor: "text-white",
    textShadow: "text-shadow-pattu",
  },
  {
    bgColor: "bg-custom-pink-300",
    bgPattern: "bg-pattern-checkerboard",
    textColor: "text-custom-yellow-300",
    textShadow: "text-shadow-fancy",
  },
  {
    bgColor: "bg-custom-yellow-100",
    bgPattern: "bg-pattern-burst",
    textColor: "text-custom-teal-500",
    textShadow: "text-shadow-trendy",
  },
];


const SubCategoriesCards = ({ category }) => {
  const { subCategories, loading } = useCategories();
  const navigate = useNavigate();

  const filteredSubCategories = useMemo(() => {
    if (!category || !subCategories?.length) return [];

    return subCategories.filter(
      (sub) =>
        !sub.hidesubCategory &&
        sub.topCategory &&
        sub.topCategory.name.toLowerCase() === category
    );
  }, [subCategories, category]);

  if (loading || !filteredSubCategories.length) return null;

  return (
<div className="bg-white py-6">
  <div className="max-w-7xl mx-auto">
    {/* SCROLL CONTAINER */}
    <div className="overflow-x-auto scrollbar-hide">
      {/* FLEX ROW */}
      <div
        className="
          flex gap-4 sm:gap-5 md:gap-6
          px-4 md:px-8
          min-w-max
          justify-start
          lg:justify-center
        "
      >
        {filteredSubCategories.map((sub, index) => {
          const style = STYLE_PRESETS[index % STYLE_PRESETS.length];

          return (
            <div
              key={sub._id}
              onClick={() => navigate(`/all-userproducts/${sub.slug}`)}
              className="cursor-pointer flex-shrink-0"
            >
              <SubCategoriesCard
                category={{
                  title: sub.name,
                  subtitle: null,
                  ...style,
                  titleSize: "text-xl md:text-2xl",
                  uppercase: true,
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  </div>
</div>

  );
};

export default SubCategoriesCards;
